import { asyncAction } from '@jarvis.oddle/core/tools/redux/action'
import {
  getStoreOrderApi,
  getEligiblePromotionsApi,
  updateStoreOrderItemQuantityApi,
  addToCartApi,
  clearCartApi,
  getTimeSlotsApi,
  updateCollectionApi,
  updatePickupLocationApi,
  updateDeliveryLocationApi,
  updateCollectionTimeApi,
  applyPromotionsApi,
  getPromoCodeApi,
  prepareCheckoutApi,
  updateDeliveryAddressTwoApi
} from 'api/fesc/client'
import { dateToRequestString, getUrlObject } from '@jarvis.oddle/core/tools/routes'
import { parsePromotion } from 'tools/promotion'
import { STORE_KEY as ORDER_STORE_KEY } from '../order/constants'
import * as C from './constants'
import { isEmpty } from '@jarvis.oddle/core/tools/string'

export const checkValidStoreOrderId = (action) => (...params) => async (dispatch, getState) => {
  const metaState = getState()['@meta']
  if (isEmpty((metaState.detailMenuSite.data || {}).storeOrderId)) {
    return { success: false, error: 'Missed storeOrderId' }
  }
  return dispatch(action(...params))
}

export const checkValidMethodOfOrder = (action) => (...params) => async (dispatch, getState) => {
  const { method, req } = params[0]
  const metaState = getState()['@meta']
  const { detailMenuSite: { data: { storeOrderId } } } = metaState
  const orderState = getState()[ORDER_STORE_KEY]
  const { data: { id, isPickup, storeId } } = orderState.storeOrder
  const reqStoreId = getUrlObject(req).query['store-id']
  if (storeOrderId === id && method === 'pickup' === isPickup && (isEmpty(reqStoreId) || reqStoreId === storeId)) {
    return { success: true }
  }
  return dispatch(action(...params))
}

export const checkValidDeliveryLocation = (action) => (...params) => async (dispatch, getState) => {
  const { address, req } = params[0]
  const metaState = getState()['@meta']
  const { detailMenuSite: { data: { storeOrderId } } } = metaState
  const reqStoreId = getUrlObject(req).query['store-id']
  const orderState = getState()[ORDER_STORE_KEY]
  const { data: {
    id,
    storeId,
    deliveryAddress,
    deliveryAddressCountry,
    deliveryAddressOne,
    deliveryAddressPostal,
    deliveryAddressTwo
  } } = orderState.storeOrder
  if (
    storeOrderId === id &&
    address.deliveryAddress === deliveryAddress &&
    address.deliveryAddressCountry === deliveryAddressCountry &&
    address.deliveryAddressOne === deliveryAddressOne &&
    address.deliveryAddressPostal === deliveryAddressPostal &&
    address.deliveryAddressTwo === deliveryAddressTwo &&
    (isEmpty(reqStoreId) || reqStoreId === storeId)) {
    return { success: true, payload: orderState }
  }
  return dispatch(action(...params))
}

export const checkValidAppointmentTime = (action) => (...params) => async (dispatch, getState) => {
  const { collectionDate, collectionTimeSlot } = params[0]
  const metaState = getState()['@meta']
  const { detailMenuSite: { data: { storeOrderId } } } = metaState
  const storeOrder = getState()[ORDER_STORE_KEY].storeOrder.data
  if (
    storeOrder.id === storeOrderId &&
    storeOrder.collectionDate === collectionDate &&
    storeOrder.collectionTime === collectionTimeSlot) {
    return { success: true }
  }
  return dispatch(action(...params))
}

export const fetchStoreOrderAction = checkValidStoreOrderId(({ req }) => asyncAction({
  api: getStoreOrderApi,
  requestAction: C.GET_STORE_ORDER_REQUEST,
  successAction: C.GET_STORE_ORDER_SUCCESS,
  failureAction: C.GET_STORE_ORDER_FAILURE
})((getState) => {
  const metaState = getState()['@meta']
  const { detailMenuSite: { data: { storeOrderId } } } = metaState
  const storeId = getUrlObject(req).query['store-id']
  return { storeOrderId, storeId, req }
}))

export const getEligiblePromotionsAction = ({ req }) => asyncAction({
  api: getEligiblePromotionsApi,
  requestAction: C.GET_ELIGIBLE_PROMO_REQUEST,
  successAction: C.GET_ELIGIBLE_PROMO_SUCCESS,
  failureAction: C.GET_ELIGIBLE_PROMO_FAILURE
})((getState) => {
  const metaState = getState()['@meta']
  const { detailMenuSite: { data: { storeOrderId } } } = metaState
  return { storeOrderId, req }
})

export const updateStoreOrderItemQuantityAction = ({ orderItemId, quantity }) => asyncAction({
  api: updateStoreOrderItemQuantityApi,
  requestAction: C.UPDATE_STORE_ORDER_ITEM_QUANTITY_REQUEST,
  successAction: C.UPDATE_STORE_ORDER_ITEM_QUANTITY_SUCCESS,
  optimisticSuccessAction: (payload) => ({ type: C.UPDATE_STORE_ORDER_ITEM_QUANTITY_OPTIMISTIC_SUCCESS, payload }),
  optimisticBackupAction: C.UPDATE_STORE_ORDER_ITEM_QUANTITY_OPTIMISTIC_BACKUP,
  failureAction: C.UPDATE_STORE_ORDER_ITEM_QUANTITY_FAILURE
})((getState) => {
  const orderState = getState()[C.STORE_KEY]
  const metaState = getState()['@meta']
  const { detailMenuSite: { data: { storeOrderId } } } = metaState
  const { data: { orderItems } } = orderState.storeOrder
  const items = orderItems.map((item) => item.id === orderItemId ? { ...item, quantity } : item)
  return { storeOrderId, items }
})

export const addItemToCartAction = ({ orderItem, menuItem, finalPrice }) => asyncAction({
  api: addToCartApi,
  requestAction: C.ADD_TO_CART_REQUEST,
  successAction: C.ADD_TO_CART_SUCCESS,
  failureAction: C.ADD_TO_CART_FAILURE
})((getState) => {
  const metaState = getState()['@meta']
  const { detailMenuSite: { data: { storeOrderId } } } = metaState
  return { storeOrderId, orderItem, menuItem, finalPrice }
})

export const clearCartAction = ({ req }) => asyncAction({
  api: clearCartApi,
  requestAction: C.CLEAR_CART_REQUEST,
  successAction: C.CLEAR_CART_SUCCESS,
  failureAction: C.CLEAR_CART_FAILURE
})((getState) => {
  const metaState = getState()['@meta']
  const { detailMenuSite: { data: { storeOrderId } } } = metaState
  return { storeOrderId, req }
})

export const fetchTimeSlotsAction = ({ date, req }) => asyncAction({
  api: getTimeSlotsApi,
  requestAction: C.GET_TIME_SLOTS_REQUEST,
  successAction: C.GET_TIME_SLOTS_SUCCESS,
  failureAction: C.GET_TIME_SLOTS_FAILURE
})((getState) => {
  const metaState = getState()['@meta']
  const { detailMenuSite: { data: { storeOrderId } } } = metaState
  return { storeOrderId, date, req }
})

export const syncMethodAction = checkValidMethodOfOrder(({ method, req }) => asyncAction({
  api: updateCollectionApi,
  requestAction: C.SYNC_METHOD_REQUEST,
  successAction: C.SYNC_METHOD_SUCCESS,
  failureAction: C.SYNC_METHOD_FAILURE
})((getState) => {
  const metaState = getState()['@meta']
  const { detailMenuSite: { data: { storeOrderId } } } = metaState
  const storeId = getUrlObject(req).query['store-id']
  return { storeOrderId, storeId, method, req }
}))

export const syncPickupLocationAction = ({ storeId, lat, long, selectedDate, req }) => asyncAction({
  api: updatePickupLocationApi,
  requestAction: C.SYNC_PICKUP_LOCATION_REQUEST,
  successAction: C.SYNC_PICKUP_LOCATION_SUCCESS,
  failureAction: C.SYNC_PICKUP_LOCATION_FAILURE
})((getState) => {
  const metaState = getState()['@meta']
  const { detailMenuSite: { data: { storeOrderId } } } = metaState
  if (lat && long && selectedDate) {
    return {
      lat: lat.toString(),
      long: long.toString(),
      selectedDate: dateToRequestString(selectedDate),
      storeOrderId,
      req
    }
  }
  return { storeOrderId, storeId, req }
})

export const syncDeliveryLocationAction = checkValidDeliveryLocation(({ address, req }) => asyncAction({
  api: updateDeliveryLocationApi,
  requestAction: C.SYNC_DELIVERY_LOCATION_REQUEST,
  successAction: C.SYNC_DELIVERY_LOCATION_SUCCESS,
  failureAction: C.SYNC_DELIVERY_LOCATION_FAILURE
})((getState) => {
  const metaState = getState()['@meta']
  const { detailMenuSite: { data: { storeOrderId } } } = metaState
  const storeId = getUrlObject(req).query['store-id']
  return { storeOrderId, storeId, address, req }
}))

export const syncDeliveryAddressTwoAction = ({ addressTwo, req = null }) => asyncAction({
  api: updateDeliveryAddressTwoApi,
  requestAction: C.SYNC_DELIVERY_ADDRESS_TWO_REQUEST,
  successAction: C.SYNC_DELIVERY_ADDRESS_TWO_SUCCESS,
  failureAction: C.SYNC_DELIVERY_ADDRESS_TWO_FAILURE
})((getState) => {
  const metaState = getState()['@meta']
  const { detailMenuSite: { data: { storeOrderId } } } = metaState
  return { storeOrderId, addressTwo, req }
})

export const syncAppointmentTimeAction = checkValidAppointmentTime(({ collectionDate, collectionTimeSlot, collectionTimeSlotId, req }) => asyncAction({
  api: updateCollectionTimeApi,
  requestAction: C.SYNC_COLLECTION_TIME_REQUEST,
  successAction: C.SYNC_COLLECTION_TIME_SUCCESS,
  failureAction: C.SYNC_COLLECTION_TIME_FAILURE
})((getState) => {
  const metaState = getState()['@meta']
  const { detailMenuSite: { data: { storeOrderId } } } = metaState
  return { storeOrderId, collectionDate, collectionTimeSlot, collectionTimeSlotId, req }
}))

// Attention: Not really used by redux store
export const applyPromotionsAction = ({ promotions, req }) => asyncAction({
  api: applyPromotionsApi,
  requestAction: C.APPLY_PROMOTIONS_REQUEST,
  successAction: C.APPLY_PROMOTIONS_SUCCESS,
  failureAction: C.APPLY_PROMOTIONS_FAILURE
})((getState) => {
  const metaState = getState()['@meta']
  const { detailMenuSite: { data: { storeOrderId } } } = metaState
  return { storeOrderId, promotions: promotions.map(parsePromotion), req }
})

// Attention: Not really used by redux store
export const checkPromoCodeAction = ({ code }) => asyncAction({
  api: getPromoCodeApi,
  requestAction: C.APPLY_PROMO_CODE_REQUEST,
  successAction: C.APPLY_PROMO_CODE_SUCCESS,
  failureAction: C.APPLY_PROMO_CODE_FAILURE
})((getState) => {
  const metaState = getState()['@meta']
  const { detailMenuSite: { data: { storeOrderId } } } = metaState
  return { storeOrderId, code }
})

export const togglePromotionAction = ({ promotion }) => ({ type: C.TOGGLE_PROMOTION, payload: { promotion } })

export const prepareCheckoutAction = () => asyncAction({
  api: prepareCheckoutApi,
  requestAction: C.PREPARE_CHECKOUT_REQUEST,
  successAction: C.PREPARE_CHECKOUT_SUCCESS,
  failureAction: C.PREPARE_CHECKOUT_FAILURE
})((getState) => {
  const metaState = getState()['@meta']
  const { cartName, detailMenuSite: { data: { storeOrderId } } } = metaState
  return { storeOrderId, cartName }
})

export const resetAppointmentAction = () => ({ type: C.RESET_APPOINTMENT_ACTION })
